import { useState, useCallback } from 'react'
import { getOrgsPosts } from '@services/PostsService'
import { Org } from '@Interfaces/Data/OrganizationInterface'

export const useOrganizationFeed = (selectedOrg: Org | null) => {
  const [feed, setFeed] = useState<any[]>([])
  const [fetching, setFetching] = useState(false)
  const [refreshing, setRefreshing] = useState(true)
  const [lastLoaded, setLastLoaded] = useState<any>(null)

  const onRefresh = useCallback(
    (showLoader?: boolean) => {
      if (!selectedOrg) return
      if (showLoader) setRefreshing(true)
      getOrgsPosts(selectedOrg).then((response) => {
        if (response.success && response.data) {
          setFeed(response.data.posts)
          setLastLoaded(response.data.lastDoc)
        }
        setRefreshing(false)
      })
    },
    [selectedOrg]
  )

  const loadMoreFeed = useCallback(() => {
    if (fetching || !selectedOrg) return
    setFetching(true)
    // TODO: Implement pagination when needed
    // getOrgFeed(
    //   currentUser,
    //   selectedOrg.id,
    //   feed,
    //   setFeed,
    //   lastLoaded,
    //   setLastLoaded,
    //   setFetching,
    //   setRefreshing
    // )
  }, [fetching, selectedOrg])

  return {
    feed,
    setFeed,
    fetching,
    setFetching,
    refreshing,
    setRefreshing,
    lastLoaded,
    setLastLoaded,
    onRefresh,
    loadMoreFeed,
  }
}
